export default __webpack_public_path__ + "static/media/Arrow.ce7dfe98.svg";